const keys = require("../config/keys");

export const API_BASE_URL = keys.apiBaseUrl;

export const ACCESS_TOKEN = "accessToken";

export const OAUTH2_REDIRECT_URI = keys.redirectUri;

export const UCL_AUTH_URL = API_BASE_URL + "/oauth2/authorize/ucl?redirect_uri=" + OAUTH2_REDIRECT_URI;

export class OPERATION_TYPE {
    static ADDITION = new OPERATION_TYPE(1, "Addition");
    static SUBTRACTION = new OPERATION_TYPE(2, "Subtraction");
    static MULTIPLICATION = new OPERATION_TYPE(3, "Multiplication");
    static DETERMINANT = new OPERATION_TYPE(4, "Determinant");
    static EIGENVALUES = new OPERATION_TYPE(5, "Eigenvalues");
    static EIGENVECTORS = new OPERATION_TYPE(6, "Eigenvectors");

    constructor(code, name) {
        this.code = code;
        this.name = name;
    }

    static fromCode(code){
        console.log(code);
        if(code == 1)
            return OPERATION_TYPE.ADDITION;
        else if(code == 2)    
            return OPERATION_TYPE.SUBTRACTION;
        else if(code == 3)    
            return OPERATION_TYPE.MULTIPLICATION;
        else if(code == 4)    
            return OPERATION_TYPE.DETERMINANT;
        else if(code == 5)    
            return OPERATION_TYPE.EIGENVALUES;
        else if(code == 6)    
            return OPERATION_TYPE.EIGENVECTORS;
        else
            return OPERATION_TYPE.ADDITION;
    }

    getCode() {
        return this.code;
    }

    toString() {
        return this.name;
    }
}